
<div
  :class="[classes(n(`--content--item-container`))]"
  v-bind="ariaAttrs"
  @click="handleClick"
  @touchstart="handleClick"
>
  <template v-if="key === KeyboardKeyType.Delete">
    <KeyboardDeleteIcon
      aria-hidden="true"
      width="48"
      height="48"
    />
  </template>
  <template v-else-if="key === KeyboardKeyType.Blank" />
  <template v-else-if="key === KeyboardKeyType.Confirm">
    {{ confirmBtnText }}
  </template>
  <template v-else>
    {{ key }}
  </template>
</div>
